import React, {createRef} from "react"

import ModalProjectConvertNew from "../project-convert-new"
import Button from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import ProjectIconUI5 from "../../../../gd-components/icons/project/project-icon-ui5"
import {ProjectSystemType} from "../../../../model2/project/types"
import projectConvert_canConvertToWorkspace from "../functions/check-convert-to-workspace"

type Props = {
    parent: ModalProjectConvertNew
}

type State = {
    search          : string,
    templateId?     : ID | ProjectSystemType.FOLDER | ProjectSystemType.WORKSPACE
}

export default class SelectProjectType extends React.Component<Props, State> {

    private inputRef: any = createRef()

    constructor(props: Props) {
        super(props);

        this.state = {
            search          : '',
            templateId      : undefined
        }
    }

    componentDidMount() {
        this.inputRef.current?.focus()
    }

    onTemplateClick(templateId: any) {
        this.setState({
            templateId: templateId
        });
    }

    onSearchCancel = () => {
        this.setState({
            search: ''
        })
    }

    onSearchChange = (event: any) => {
        const { value } = event.target

        this.setState({
            search: value ? value : ''
        })
    }

    closeModal = () => {
        gd.modal.hide();
    }

    onSubmit = () => {
        if (!this.state.templateId) return

        this.props.parent.onTemplateTypeSelected(this.state.templateId)
    }

    renderHeader() {
        return (
            <div className="header h-110">
                <div className="title">Convert to</div>
                <div className="search">
                    <input ref          = {this.inputRef}
                           type         = "input"
                           value        = {this.state.search}
                           onChange     = {this.onSearchChange}
                           placeholder  = "Search"/>

                    <div className="i5-search"/>

                    {!!this.state.search &&
                        <div className="i5-delete" onClick={this.onSearchCancel}> </div>}
                </div>

                <div className="i5-delete" onClick={this.closeModal}/>
            </div>
        )
    }

    renderSubmit() {
        const type = !!this.state.templateId ? 'primary' : 'disabled'
        const label = "Convert"

        return (
            <div className="modal-submit flex-row-center-center">
                <Button type={type} label={label} onClick={this.onSubmit}/>
            </div>
        )
    }

    render() {
        const searchText    = this.state.search ? this.state.search.trim().toLowerCase() : false
        const models        = gd.session.templatesList.models.slice()

        const projectIds = _.compact([this.props.parent.props.params.projectId].concat(this.props.parent.props.params.projectIds))
        const canConvertToWorkspace = projectConvert_canConvertToWorkspace(projectIds)

        const templates = _.chain(models)
            .filter(t=>t.companyId === gd.companyId &&
                !t.isDeleted &&
                (!searchText || t.name.trim().toLowerCase().includes(searchText))
            )
            .orderBy(t=>t.sortPosition)
            .value();

        return (
            <>
                {this.renderHeader()}

                <div className="main">
                    <div className="project-templates">
                        <div className="ui5-notification notification-inline  m-b-10">
                            <div className="message fl-ac">
                                <div className="icon ui5-ico-13 ii5-information m-r-10"/>
                                <div className="text flex-row">
                                    Project conversion updates/reset all settings including views, workflows custom fields and task types.
                                </div>
                            </div>
                        </div>

                        <div className="ui5-title-small m-t-15 m-b-10 m-l-5">System</div>

                        <div className  = {Classes("select-tile",{selected: this.state.templateId === ProjectSystemType.FOLDER})}
                             onClick    = {()=>{this.onTemplateClick(ProjectSystemType.FOLDER)}}>
                            <div className="gd-ui-project-icon ui5-ico-13 ii5-folder option-icon"/>
                            <div className="option-title">Folder</div>
                        </div>

                        {canConvertToWorkspace &&
                            <div className  = {Classes("select-tile no-border",{selected: this.state.templateId === ProjectSystemType.WORKSPACE})}
                                 onClick    = {()=>{this.onTemplateClick(ProjectSystemType.WORKSPACE)}}>
                                <div className="gd-ui-project-icon ui5-ico-13 i5-departments option-icon"/>
                                <div className="option-title">Workspace</div>
                            </div>}

                        <div className="ui5-title-small m-t-20 m-b-10 m-l-5">Project Template</div>

                        {_.map(templates, (t,key)=>
                            <div key        = {key}
                                 className  = {Classes("select-tile",{selected: this.state.templateId === t.id})}
                                 onClick    = {()=>{this.onTemplateClick(t.id)}}>
                                <ProjectIconUI5 className="option-icon" project={t}/>
                                <div className="option-title">{t.name}</div>
                            </div>)}

                        {this.state.search && templates.length === 0 && <div className="not-found">No project templates found</div>}
                    </div>
                </div>

                {this.renderSubmit()}
            </>
        )
    }
}
